<template>
    <div class="f-nav-static">
        <div class="nav-tab">
            <div class="nav-horizontal"
              v-show="!dropDown"
              :class="{'show-icon': hasDropDown}">
                <ul class="list-wrap transition">
                    <li v-for="item in listItem"
                        class="list"
                        :class="{ 'active': item.active }"
                        :data-type="item.type"
                        :data-id="item.id"
                        :key="item.id"
                        v-on:click="onListClickHandle">
                        <span>{{ item.text }}</span>
                    </li>
                </ul>
            </div>
            <div class="nav-title" v-show="dropDown">全部分类</div>
        </div>
        <div class="nav-icon"
               :class="{ 'rotate': dropDown}"
               v-show="hasDropDown"
               v-on:click="onToggleHandle">
            <img src="//cdn.upin.com/mfanhuan/images/home/icon-tab-order.png">
        </div>
        <div class="nav-dropdown" v-show="dropDown">
            <div class="row" v-for="(row, index) in rowlist" :key="index">
                <ul class="list-wrap">
                    <li v-for="item in row"
                        class="list"
                        :class="{ 'active': item.active }"
                        :data-type="item.type"
                        :data-id="item.id"
                        :key="item.id"
                        v-on:click="onListClickHandle">
                        <span>{{ item.text }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="nav-mask"
             v-show="dropDown"
             v-on:click="onToggleHandle"></div>
    </div>
</template>

<script>
    import utils from '../utils'

    var touchStart = 0
    var navOffsetLeft = 0

    export default {
        name: 'f-nav-static',
        data () {
            return {
                dropDown: false,
                list: this.listItem
            }
        },
        props: {
            listItem: {
                type: Array,
                required: true
            },
            hasDropDown: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            listItem: function () {
                this.$nextTick(function () {
                    this.calcNavTabWidth()
                })
            }
        },
        computed: {
            activeItem: {
                get () {
                    for (let i = 0, len = this.listItem.length; i < len; i++) {
                        if (this.listItem[i].active) {
                            return this.listItem[i]
                        }
                    }
                },
                set (id) {
                    for (let i = 0, len = this.listItem.length; i < len; i++) {
                        let item = this.listItem[i]
                        item.active = false

                        if (item.id === id) {
                            item.active = true
                        }
                    }
                }
            },
            rowlist: function () {
                var list = []
                var row = []

                for (let i = 0, len = this.listItem.length; i < len; i++) {
                    row.push(this.listItem[i])
                    if (row.length === 4) {
                        list.push(row)
                        row = []
                    }
                }

                if (row.length > 0) {
                    list.push(row)
                }
                return list
            }
        },
        methods: {
            onListClickHandle (e) {
                var target = utils.closest(e.target, 'list')
                var id = target.getAttribute('data-id')
                var self = this

                this.activeItem = id
                var activeItem = this.activeItem
                this.$emit('nav-item-click', e, JSON.parse(JSON.stringify(activeItem)))

                this.dropDown = false

                this.$nextTick(function () {
                    self.navScrollCenter()
                })
            },
            onToggleHandle () {
                this.dropDown = !this.dropDown
            },
            onNavTouchstart (e) {
                var touchPoint = e.touches[0]
                var $nav = document.querySelector('.nav-horizontal .list-wrap')

                touchStart = touchPoint.pageX
                navOffsetLeft = $nav.offsetLeft
                $nav.classList.remove('transition')
            },
            onNavTouchmove (e) {
                e.preventDefault()

                var touchPoint = e.touches[0]
                var $nav = document.querySelector('.nav-horizontal .list-wrap')
                var $navIcon = document.querySelector('.f-nav-static .nav-icon')
                var moveX = touchPoint.pageX - touchStart
                var offsetLeft = navOffsetLeft + moveX
                var maxLeft = $nav.offsetWidth - document.body.clientWidth + $navIcon.offsetWidth

                offsetLeft = offsetLeft > 0 ? 0 : offsetLeft
                offsetLeft = offsetLeft < (-maxLeft) ? (-maxLeft) : offsetLeft

                $nav.style.left = offsetLeft + 'px'
            },
            onNavTouchend () {
                var $nav = document.querySelector('.nav-horizontal .list-wrap')
                $nav.classList.add('transition')
            },
            navScrollCenter () {
                var clientWidth = document.body.clientWidth
                var $navWrap = document.querySelector('.nav-horizontal')
                var $nav = document.querySelector('.nav-horizontal .list-wrap')
                var $navIcon = document.querySelector('.f-nav-static .nav-icon')
                var $activeLi = $nav.querySelector('.active')
                var maxLeft = $nav.offsetWidth - clientWidth + $navIcon.offsetWidth

                if (!$activeLi) return

                var midPoint = (clientWidth - $activeLi.offsetWidth) / 2
                var offsetLeft = midPoint - $activeLi.offsetLeft

                offsetLeft = offsetLeft > 0 ? 0 : offsetLeft
                offsetLeft = offsetLeft < (-maxLeft) ? (-maxLeft) : offsetLeft

                $navWrap.scrollLeft = Math.abs(offsetLeft)
            },
            getActiveItem () {
                return JSON.parse(JSON.stringify(this.activeItem))
            },
            calcNavTabWidth () {
                var $navTab = document.querySelector('.f-nav-static .nav-tab')
                var $listWrap = $navTab.querySelector('.list-wrap')
                var $list = $navTab.querySelectorAll('.list')
                var width = 0
                var isHTC = navigator.userAgent.toLowerCase().indexOf('htc') > -1 && navigator.userAgent.toLowerCase().indexOf('d826w') > -1
                var isSM = navigator.userAgent.toLowerCase().indexOf('samsung sm-n9002') > 0
                $listWrap.style.width = '9999px'

                for (let i = 0, len = $list.length; i < len; i++) {
                    var listWidth = $list[i].offsetWidth

                    if (isHTC) {  // htc d826计算出来的宽度不准确，做个修正
                        listWidth += this.listItem[i].text.length - 2
                    }

                    if (isSM) {
                        listWidth = this.listItem[i].text.length * 17 + 24
                    }

                    width += listWidth
                }

                var clientWidth = document.body.clientWidth
                $listWrap.style.width = (width > clientWidth ? width : clientWidth) + 'px'

                this.navScrollCenter()
            },
            init () {
                this.$nextTick(function () {
                    this.calcNavTabWidth()
                })
            }
        },
        mounted () {
            this.init()
        }
    }
</script>

<style lang="stylus">
    .f-nav-static
        position: relative
        font-size: 17px
        color: #333
        margin: 0
        padding: 0
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
        background: #fff
        .list-wrap
            display: -webkit-box
            display: -webkit-flex
            display: flex
            -webkit-box-pack: start
            -webkit-justify-content: start
            justify-content: flex-start
            -webkit-box-align: stretch
            -webkit-align-items: stretch
            align-items: stretch
            height: 40px
            list-style: none
            margin: 0
            padding: 0
            .list
                position: relative
                display: -webkit-box
                display: -webkit-flex
                display: flex
                -webkit-box-pack: center
                -webkit-justify-content: center
                justify-content: center
                -webkit-box-align: stretch
                -webkit-align-items: stretch
                align-items: stretch
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
                padding: 0 7px
                span
                    line-height: 40px
                    padding: 0 5px
                    display: block
                    word-spacing: 0
                    letter-spacing: 0
            .active
                &:after
                    content: ''
                    position: absolute
                    left: 50%
                    margin-left: -13px
                    bottom: 0
                    width: 27px
                    height: 3px
                    background: #ff3444
                span
                    color: #ff3444
        .nav-tab
            position: relative
            z-index: 10
            background: #fff
            height: 40px
            overflow: hidden
            &:after
                content: ''
                position: absolute
                left: 0
                background: #e8e8e8
                width: 100%
                height: 1px
                transform: scaleY(0.5)
                transform-origin: left bottom
                bottom: 0
                z-index: -1
            .nav-horizontal
                overflow: hidden
                overflow-x: scroll
                -webkit-overflow-scrolling: touch
                height: 50px
                &::-webkit-scrollbar
                    display: none
            .nav-horizontal.show-icon
                margin-right: 40px
            .nav-title
                height: 40px
                font-size: 16px
                line-height: 40px
                text-align: center
            .list-wrap
                width: 9999px
                position: relative
                -webkit-transform: translateZ(0px)
            .list-wrap.transition
                transition: left ease-in-out 300ms
        .nav-icon
            position: absolute
            width: 40px
            height: 39px
            top: 0
            right: 0
            background: rgba(255,255,255,.94)
            display: -webkit-box
            display: -webkit-flex
            display: flex
            -webkit-box-pack: center
            -webkit-justify-content: center
            justify-content: center
            -webkit-box-align: center
            -webkit-align-items: center
            align-items: center
            z-index: 10
            img
                width: 15px
                transition: transform ease-in-out 300ms
        .nav-icon.rotate img
                transform: rotate(180deg)
        .nav-dropdown
            position: absolute
            width: 100%
            left: 0
            top: 40px
            z-index: 10
            background: #fff
            .list-wrap
                height: auto
                -webkit-box-lines: multiple
                -webkit-flex-wrap: wrap
                flex-wrap: wrap
                .list
                    width: 25%
                    height: 40px
                    margin-top: 10px
                    padding: 0
                    span
                        padding: 0 6px
        .nav-mask
            position: fixed
            left: 0
            right: 0
            top: 0
            bottom: 0
            background: rgba(0,0,0,.7)
            width: 100%
            height: 100%
            z-index: 1
                
</style>


// WEBPACK FOOTER //
// nav-static.vue?7f8b5580